import { useContext } from "react";

import { Redirect, Switch, useRouteMatch } from "react-router-dom";

import Route from "@/components/AuthRoute";
import ReportsRouteGuard from "@/components/reports/ReportsRouteGuard";
import { ViewerContext } from "@/tpo/Viewer";

import ReportDetail from "./ReportDetail";
import WardReportPrint from "./ReportPrint";
import Reports from "./Reports";
import { REPORTS_LIST_QUERY, WARD_ENTITLEMENTS_QUERY } from "./graphql/queries";

export default function WardReportsRoutes() {
  const match = useRouteMatch();
  const { userId } = useContext(ViewerContext);

  return (
    <ReportsRouteGuard
      reportsQuery={REPORTS_LIST_QUERY}
      reportsQueryVariables={{ userId }}
      entitlementsQuery={WARD_ENTITLEMENTS_QUERY}
      entitlementsQueryVariables={{ userId }}
      skip={!userId}
    >
      <Switch>
        <Route exact path={match.path} component={Reports} />
        <Route exact path={`${match.path}/:reportSlug/print`} component={WardReportPrint} />
        <Route exact path={`${match.path}/:reportSlug/:tab`} component={ReportDetail} />
        <Redirect from={`${match.path}/:reportSlug`} to={`${match.path}/:reportSlug/overview`} exact />
      </Switch>
    </ReportsRouteGuard>
  );
}
